export default __webpack_public_path__ + "static/media/024-account.6ffc8dcb.svg";